import React, { useEffect, useRef, useState } from "react";
import vid from "../src/Media/Comp 2.mp4";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function MainVideo() {
  const matches = useMediaQuery("(min-width:635px)");
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  return (
    <div style={{ position: "relative" }} dir={isArabic ? "rtl" : "ltr"}>
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <video
          src={vid}
          autoPlay
          muted
          loop
          width="100%"
          height={matches ? "600" : "400"}
          style={{ objectFit: "fill", opacity: "0.9" }}
          className="w-full h-full object-cover z-0 rounded-lg lg:rounded-3xl"
        ></video>
        <div
          style={{
            position: "absolute",
            top: "150px",
            left: isArabic ? "" : "40px",
            right: isArabic ? "40px" : "",
          }}
        >
          <Stack>
            <Typography
              sx={{
                padding: "20px",
                fontWeight: "bold",
                fontSize: "25px",
                color: "#20C4F0",
                bgcolor: "#D8D8D842",
                borderRadius: "20px",
              }}
            >
              {t("Focus Trading Company")}
            </Typography>

            <Typography
              sx={{ padding: "20px", fontSize: "30px", color: "white" }}
            >
              {t("Take Your")} <br />
              {t("Business To")} <br />
              {t("The Next Level")}
            </Typography>

            <Typography
              sx={{
                padding: "20px",
                fontSize: "16px",
                color: "#20C4F0",
              }}
            >
              {t("From Syria To The World")}
            </Typography>
          </Stack>
        </div>
      </Box>
    </div>
  );
}

// export default function FirstSlide() {
//   const matches = useMediaQuery("(min-width:635px)");

//   return (
//     <Box sx={{  justifyContent:'center',alignItems:'center',display:'flex',flexWrap:"wrap"}} >
//         <video src={vid}  autoPlay loop muted width={matches?"75%":'100%'} height="500" style={{ borderRadius:'20px',objectFit:'fill'}}
//         class="w-full h-full object-cover z-0 rounded-lg lg:rounded-3xl">
//           </video>
//     </Box>
//   )
// }
